import { type IndexedDBConnector } from '@/types/accessor/common/connector'
import * as indexedDB from './common/indexedDBController'
import { handleError } from '../util/errorHandler'
import { METHOD, SEND_STATE } from '@/constants/accessor/indexedDB/indexedDB'

const STORE_NAME = 'disaster'
const IDB_ERROR_CODE = 'idb_08'

/**
 * 共通エラーレスポンス
 */
export interface DisastersApiErrorResponse {
  error: string
}

/**
 * queryのパラメータ
 */
export interface QueryParam {
  system: string
  govCode: string
  disasterTypes: string[]
}

/**
 * queryのレスポンス
 */
export interface QueryResponse extends DisastersApiErrorResponse {
  result: ResQueryDisasters[]
}

/**
 * 災害情報API(query)レスポンス
 */
export interface ResQueryDisasters {
  govCode: string
  disasterId: string
  disasterTypes: string[]
  disasterName: string
  occurrenceDate: number
  occurrenceDateUnit: string
  isEnabled: boolean
  recommendedDisasterType?: string
}

/**
 * IndexedDBにデータを挿入する
 * @param data 挿入するデータ
 * @returns なし
 */
export const set: IndexedDBConnector<QueryResponse, undefined, void> = async (
  data?: QueryResponse
): Promise<void> => {
  if (!data) {
    console.error('Data is undefined')
    return
  }
  await Promise.all(
    data.result.map(async (d: ResQueryDisasters) => {
      await indexedDB.set(STORE_NAME, d, METHOD.GET, SEND_STATE.FETCHED, d.disasterId)
    })
  ).catch(async () => await handleError(IDB_ERROR_CODE))
}

/**
 * 指定されたキー情報に基づくデータをIndexedDBから取得する
 * @param params データ取得用のキー情報
 * @returns 取得したデータ
 */
export const get: IndexedDBConnector<string, undefined, unknown> = async (
  key?: string
): Promise<unknown> => {
  const result = await indexedDB.get(STORE_NAME, key as string).catch(async () => {
    await handleError(IDB_ERROR_CODE)
    return undefined
  })
  return result
}

/**
 * inspectionResultテーブルのすべてのデータを返却する
 * @param なし
 * @returns 取得結果
 */
export const getAll: IndexedDBConnector = async () => {
  return {
    result: await indexedDB.getAll(STORE_NAME).catch(async () => await handleError(IDB_ERROR_CODE))
  }
}
